import {
  call, put, delay, select,
} from 'redux-saga/effects';
import moment from 'moment/moment';
import processError from '../../../utils/processError';
import {
  addProgressLog, setProgressList, showProgressBar, stoppedProgressBar,
} from '../../System/actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { USER_COMMAND_NAMES } from '../../../configs';
import { localeFormatter } from '../../../utils/formatters';
import { SYSTEM_MODULE } from '../../../configs/moduleNames';
import {
  acceptApplication, archiveApplication,
  assignApplicationById, deleteApplication,
  deniedApplication,
  returnApplication,
  suspendedApplication, unarchiveApplication,
  applicationBatchCommandFailed, applicationBatchCommandSuccessful, loadApplicationById, restoreApplication,
} from '../actions';
import { BAD_REQUEST } from '../../../configs/serverStatusCodes';

const getStop = state => {
  const {
    [SYSTEM_MODULE]: {
      stopProgressBar = false,
    },
  } = state;
  return stopProgressBar;
};

const BATCH_COMMAND_ACTIONS = {
  [USER_COMMAND_NAMES.DENIED]: deniedApplication,
  [USER_COMMAND_NAMES.INACTIVE]: suspendedApplication,
  [USER_COMMAND_NAMES.RETURNED]: returnApplication,
  [USER_COMMAND_NAMES.ACCEPTED]: acceptApplication,
  [USER_COMMAND_NAMES.DELETED]: deleteApplication,
  [USER_COMMAND_NAMES.ARCHIVED]: archiveApplication,
  [USER_COMMAND_NAMES.IN_ARCHIVED]: unarchiveApplication,
  [USER_COMMAND_NAMES.RESTORE]: restoreApplication,
};

export default function* applicationBatchCommand(action) {
  try {
    if (!action.payload.items || !Array.isArray(action.payload.items) || !action.payload.key) {
      throw new Error(BAD_REQUEST);
    }

    let result = 0;
    let stopImport = false;
    const {
      items, key, values, withAssign = true,
    } = action.payload;

    yield put(showProgressBar({
      title: `Пакетное [${localeFormatter('user.command', key)}]`,
      text: 'group.user.command',
    }));

    for (const item of items) {
      stopImport = yield select(getStop);

      const promiseApplication = yield put(loadApplicationById(item));
      const { mais_egu_id } = yield promiseApplication;
      const time = moment().format('HH:mm:ss');

      if (!mais_egu_id) {
        yield put(addProgressLog({ log: `<span style="color: red">${time} - Обращение не имеет номера</span>`, withOutTime: true }));
        continue;
      }

      try {
        if (withAssign) {
          const promiseAssign = yield put(assignApplicationById(item));
          yield promiseAssign;
        }

        const promiseCommand = yield put(BATCH_COMMAND_ACTIONS[key](values ? { id: item, values } : item));
        yield promiseCommand;

        yield put(addProgressLog({ log: `Обращение № ${mais_egu_id} - [${localeFormatter('user.command', key)}] успех` }));
      } catch (error) {
        yield put(addProgressLog({ log: `<span style="color: red">${time} - Обращение № ${mais_egu_id} - [${localeFormatter('user.command', key)}] ${error?.message}</span>`, withOutTime: true }));
      }
      result++;
      yield put((setProgressList({
        progressCountSuccess: result,
        progressPercent: (result / items.length) * 100,
        progressCount: items.length,
      })));

      if (stopImport) {
        yield put(stoppedProgressBar());
        break;
      }
      yield delay(1000);
    }

    yield put(addProgressLog({ log: `Пакетное [${localeFormatter('user.command', key)}] завершено` }));
    yield put(stoppedProgressBar());
    yield put(setProgressList({
      progressCountSuccess: result,
      progressPercent: 100,
      progressCount: items.length,
    }));
    yield put(applicationBatchCommandSuccessful());
    yield call(resolveActionPromise(action));
  } catch (e) {
    yield put(applicationBatchCommandFailed());
    yield handleImportFailure(e);
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}

function* handleImportFailure(error) {
  const time = moment().format('HH:mm:ss');
  yield put(addProgressLog({ log: `<span style="color: red">${time} - Ошибка импорта: ${error || 'Ошибка без сообщения'}</span>`, withOutTime: true }));
  yield put(stoppedProgressBar());
  yield put(setProgressList({ progressPercent: 100 }));
}
